import React from 'react';
import styles from './style.module.css';

const currentYear = new Date().getFullYear();

export default ({
    pagination
}) => (
    <div className={pagination ? styles.footerPagination : styles.footer}>
        <div className={styles.container}>
            <p>&reg; {currentYear} Libro Credit Union. All rights reserved.</p>
        </div>
    </div>
);
